<template>
    <div v-if="!loading && list" class="w-full flex flex-column gap-3 max-w-30rem">
        <div class="flex w-full justify-content-start">
            <Button :label="content[lang_].add_sender" @click="$router.push({ path: '/personal/sender/add/' })" 
                class="flex border-round-xl" severity="info" icon="pi pi-plus" size="small" />
        </div>
        <MobMenu v-if="list.length>0" :items="[]" :footerTxt="content[lang_].footer">
            <template v-slot:body>
                <div v-for="item of list" @click="goToSender(item)" style="min-height:50px" 
                    class="w-full flex flex-row px-3 py-2 border-100 border-bottom-1" 
                    :class="isRejected(item) ? 'cursor-pointer': ''">
                    <div class="flex mr-3 align-items-center">
                        <Avatar class="text-600" size="small" icon="pi pi-user" shape="circle"/>
                    </div>
                    <div class="flex flex-1 flex-column gap-2 justify-content-left">
                        <span class="flex text-600">{{ item.first_name }} ({{item.last_name}})</span>
                        <div class="flex-1 flex-column">
                            <Tag :severity="getKycSeverity(item.kyc.status)" class=" text-xs">
                                {{ getKycStatus(item.kyc.status) }}
                            </Tag>
                        </div>
                    </div>
                    <div v-if="isRejected(item)"
                        class="flex justify-content-right align-items-center cursor-pointer" >
                        <span v-if="(screenSize != 'xs' && screenSize != 'sm')" class="text-xs text-blue-500">{{ content[lang_].change }}</span>
                        <i class="text-blue-500 ml-2" :class="'pi pi-angle-right'" />
                    </div>
                </div>
            </template>
        </MobMenu>  
        <div v-if="list.length>0" class="flex w-full align-items-center justify-content-center surface-0 border-round-2xl">
            <Paginator v-if="total && total>rows" 
                :rows="rows" :first="skip" :totalRecords="total" :rowsPerPageOptions="[10, 20, 30]" @update:first="onChangePage" 
                template="PrevPageLink PageLinks NextPageLink" class="flex"/>
        </div>
        <div v-else class="w-full flex flex-column p-3 surface-0 border-round-xl xl:border-round-2xl lg:border-round-2xl md:border-round-xl">
            <span class="text-900 text-sm text-center">
                {{ content[lang_].empty }}
            </span>
        </div>
    </div>
</template>

<script>
import Connect from         '@/assets/js/Connect.js'
import Helper from          '@/assets/js/Helper.js'
import MobMenu from         '@/components/sides/menu/MobMenu.vue' 

export default {
    props: {
        list: { 
            type: Array, 
            default: () => [] 
        },
        total: { 
            type: Number, 
            default: 0 
        },
        rows: { 
            type: Number, 
            default: 10 
        },
        skip: { 
            type: Number, 
            default: 0 
        },
        loading: { 
            type: Boolean, 
            default: true 
        }
    },
    data() {
        return {
            content: {
                en: { 
                    empty: 'No senders',
                    trans: 'senders',
                    from: 'from',
                    copy: 'Copied',
                    change: 'Change',
                    add_sender: 'Add sender',
                    footer: 'Sender data must match your bank data when sending funds. If the data does not match, the transfer may be returned to your account.'
                },
                ru: { 
                    empty: 'Нет отправителей',
                    trans: 'отправителей',
                    from: 'из',
                    copy: 'Скопировано',
                    change: 'Изменить',
                    add_sender: 'Добавить отправителя',
                    footer: 'Данные отправителей должны совпадать с данными из вашего банка при отправке средств. Если данные не совпадают, то перевод может быть возвращен обратно на ваш счет.'
                }
            },
        }
    },
    components: {
        MobMenu
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        screenSize() { return this.$store.getters.StateScreenSize },
    },
    methods: {
        getKycSeverity(status){
            return this.helper.getKycSeverity(status)
        },
        getKycStatus(status){
            return this.helper.getKycStatus(status)
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: this.content[this.lang_].copy, detail: text, life: 1000 })
        },
        isRejected(sender){
            return sender.kyc && sender.kyc.status && (sender.kyc.status=='rejected' || sender.kyc.status=='pending')
        },
        goToSender(sender){
            if(!sender) return
            if(!sender.id) return
            if(!this.isRejected(sender)) return
            this.$router.push({ path: `/personal/sender/edit/${sender.id}` })
        },
        onChangePage(event) {
            this.$emit('update:first', event)
        },
        onChangeRows(event) {
            this.$emit('update:rows', event)
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>